import Layout from '@/layout';
import _import from './_import';
export const asyncRouterHandle = asyncRouter => {
  asyncRouter.map(item => {
    if (item.component) {
      if (item.component === 'layout') {
        item.component = Layout;
      } else {
        item.component = _import(item.component);
      }
    } else {
      delete item['component'];
    }
    if (item.children) {
      asyncRouterHandle(item.children);
    }
  });
};